import { Box, styled, Flex } from '@withjoy/joykit';

export const WeddingContentWrapper = styled(Flex)`
  min-height: 100vh;
`;

export const StyledCreateWeddingRoot = styled(Box)`
  display: flex;
  min-height: 100vh;
`;

export const Background = styled.div`
  flex: 1;
  max-width: 100%;
`;

export const StyledOnboardingRoot = styled(Flex)`
  justify-content: space-between;
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm2}) {
    max-height: 100%;
  }
`;

export const SidebarRoot = styled.aside`
  display: none;
  width: 57%;
  background: radial-gradient(93.16% 97.01% at 43.79% 20.94%, #fff9f5 0%, #fef8f4 50%, #fff0e4 100%);

  @media (min-width: 863px) {
    display: flex;
    flex-direction: column;
  }
`;

export const SidebarContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  position: relative;
  overflow-y: hidden;
  opacity: 1;
  justify-content: center;
  align-items: center;
`;

export const SidebarContentWrapper = styled(Box)`
  padding: 32px;
  width: 439px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm2}) {
    margin: 32px;
  }
`;

export const Variant1Img = styled.img`
  width: 375px;
`;

export const Variant2Img = styled.img`
  width: 375px;
  border-radius: 8px;
`;

export const ContentRoot = styled.main`
  border-right: solid 0.0625rem ${({ theme }) => theme.colors.mono4};
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100vw;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm2}) {
    overflow: visible;
  }

  @media (min-width: 863px) {
    width: 43%;
  }
`;
